/* @flow */

export const supportEmail = 'support@braindate.com';
